// @flow
import moment from 'moment';
import DateRange from 'common/domain/DateRange';
import Salesman from 'common/modules/salesman/domain/Salesman';
import type { PropositionState } from './proposition';
import Proposition, { ACCEPTED_STATE, PROPOSED_STATE, CANCELLED_STATE, DRAFT_STATE } from './proposition';

interface ListingCustomer {
  name: string;
}

type PropositionListingData = {
  reference: string;
  callSign?: ?string;
  title: string;
  state: PropositionState;
  totalCost?: ?number;
  totalOpportunities?: ?number;
  proposedOn?: ?moment;
  dateRange?: ?DateRange;
  customer: ?ListingCustomer;
  salesman?: ?Salesman;
}

export default class PropositionListing {

  reference: string;
  callSign: ?string;
  title: string;
  state: PropositionState;
  totalCost: ?number;
  totalOpportunities: ?number;
  proposedOn: ?moment;
  dateRange: ?DateRange;
  customer: ?ListingCustomer;
  salesman: ?Salesman;

  constructor(data: PropositionListingData) {
    this.reference = data.reference;
    this.callSign = data.callSign;
    this.title = data.title;
    this.state = data.state;
    this.totalCost = data.totalCost;
    this.totalOpportunities = data.totalOpportunities;
    this.proposedOn = data.proposedOn;
    this.dateRange = data.dateRange;
    this.customer = data.customer;
    this.salesman = data.salesman;
  }

  isAccepted(): boolean {
    return this.state === ACCEPTED_STATE;
  }

  isProposed(): boolean {
    return this.state === PROPOSED_STATE;
  }

  isCancelled(): boolean {
    return this.state === CANCELLED_STATE;
  }

  isDrafted(): boolean {
    return this.state === DRAFT_STATE;
  }

  getTotalCost() {
    return this.totalCost;
  }

  getCustomerName() {
    return this.customer ? this.customer.name : '-';
  }

  static fromProposition(proposition: Proposition) {
    return new PropositionListing({
      reference: proposition.reference,
      callSign: proposition.radio && proposition.radio.callSign,
      title: proposition.title,
      state: proposition.state,
      totalCost: proposition.totalCost,
      totalOpportunities: proposition.getTotalOpportunities(),
      proposedOn: proposition.proposedOn,
      dateRange: proposition.dateRange,
      customer: proposition.customer,
      salesman: proposition.salesman,
    });
  }

  static parse(data: Object) {
    return new PropositionListing({
      reference: data.reference,
      callSign: data.callSign,
      title: data.title,
      state: data.state,
      totalCost: data.totalCost,
      totalOpportunities: data.numberOfSpots,
      proposedOn: data.proposedOn,
      dateRange: DateRange.fromISO(data),
      customer: data.customer,
      salesman: data.salesman && Salesman.parse(data.salesman),
    });
  }

}



// WEBPACK FOOTER //
// ./src/common/modules/proposition/domain/propositionListing.js